import { useLoggingQuery } from 'lib/apollo/apollo-hooks';

import { studentAuthApolloContextOption } from 'approot/student-class-to-do/student-class-to-do.utils';
import { GET_CLASS_SETTINGS } from 'approot/classes/class-settings.graphql';
import type {
  GetClassSettingsQuery,
  GetClassSettingsQueryVariables,
} from '../classes/class-settings.graphql.generated';
import { getStudentClassToDoClassId } from './logic/get-student-class-to-do-class-id';

export const useStudentClassSettings = () => {
  const classId = getStudentClassToDoClassId();

  const { data, loading } = useLoggingQuery<
    GetClassSettingsQuery,
    GetClassSettingsQueryVariables
  >(
    GET_CLASS_SETTINGS,
    {
      context: studentAuthApolloContextOption(),
      skip: !classId,
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          classId: classId!,
        },
      },
    },
    false
  );
  const settings = data?.getClassSettings;

  const backgroundVisibility =
    !settings || settings.backgroundVisibility === null
      ? true
      : settings.backgroundVisibility;
  const animationAutoPlay =
    !settings || settings.animationAutoPlay === null
      ? true
      : settings.animationAutoPlay;
  const translationEnabled = !!settings?.translationEnabledStudent;
  const ttsEnabled = !!settings?.ttsEnabled;
  return {
    data,
    loading,
    backgroundVisibility,
    animationAutoPlay,
    translationEnabled,
    ttsEnabled,
  };
};
